import { Routes } from '@angular/router';
import { RenderInterfaceGuard } from 'viggo-sistemas-core-web';


export const routesAdminParametrizacao: Routes = [
  {
    path: 'protocolos',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'PROTOCOLOS',
      menuKey: 'CADASTRO',
      subMenuKey: 'PARAMETRIZACOES',
      breadcrumb: {
        label: 'Protocolos',
        icon: 'mdi mdi-receipt-text-outline'
      },
      backend_path: '/protocolos'
    },
    loadChildren: () =>
      import('@app/modules/protocolo/protocolo.module').then(
        m => m.ProtocoloModule
      )
  },
  {
    path: 'procedimentos',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'PROCEDIMENTOS',
      menuKey: 'CADASTRO',
      subMenuKey: 'PARAMETRIZACOES',
      breadcrumb: {
        label: 'Procedimentos',
        icon: 'mdi mdi-bandage'
      },
      backend_path: '/procedimentos'
    },
    loadChildren: () =>
      import('@app/modules/procedimento/procedimento.module').then(
        m => m.ProcedimentoModule
      )
  },
  {
    path: 'planos_saude',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'PLANOS_SAUDE',
      menuKey: 'CADASTRO',
      subMenuKey: 'PARAMETRIZACOES',
      breadcrumb: {
        label: 'Planos de saúde',
        icon: 'mdi mdi-hospital-building'
      },
      backend_path: '/planos_saude'
    },
    loadChildren: () =>
      import('@app/modules/plano_saude/plano_saude.module').then(
        m => m.PlanoSaudeModule
      )
  },
  {
    path: 'formularios',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'FORMULARIOS',
      menuKey: 'CADASTRO',
      subMenuKey: 'PARAMETRIZACOES',
      breadcrumb: {
        label: 'Formulários',
        icon: 'mdi mdi-note-outline'
      },
      backend_path: '/formularios'
    },
    loadChildren: () =>
      import('@app/modules/formulario/formulario.module').then(
        m => m.FormularioModule
      )
  },
  {
    path: 'motivos_cancelamento',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'MOTIVO_CANCELAMENTO',
      menuKey: 'CADASTRO',
      subMenuKey: 'PARAMETRIZACOES',
      breadcrumb: {
        label: 'Motivo cancelamento',
        icon: 'pi pi-fw pi-times-circle'
      },
      backend_path: '/motivos_cancelamento'
    },
    loadChildren: () =>
      import('@app/modules/motivo_cancelamento/motivo-cancelamento.module').then(
        m => m.MotivoCancelamentoModule
      )
  }
];
